// Used to update an atributte of an specific model
const UpdateDataUtil = ({ updateData, input, query, loanId }) => (
  updateData({
    variables: {
      input
    },
    update: (store, { data: { modelAttribute: { loan } } }) => {
      const variables = { loanId }
      const data = store.readQuery({ query, variables })
      data.loan = loan
      store.writeQuery({ query, variables, data })
    }
  })
)

export default UpdateDataUtil